import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCriceleAlert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 45,
	viewBox: "0 0 43 45",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25.891,
			cy: 28.5,
			rx: 3.76599,
			ry: 3.5,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 25,
			r: 17,
			fill: "#FFDDBD"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 39.5318,
			cy: 37.5,
			rx: 2.53176,
			ry: 2.5,
			fill: "#FC8210"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.0127,
			cy: 44,
			rx: 1.0127,
			ry: 1,
			fill: "#FFC997"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.0127,
			cy: 1,
			rx: 1.0127,
			ry: 1,
			fill: "#FC8210"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 23.5,
			cy: 7.5,
			r: 2.5,
			fill: "#FFDDBD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 44C28.9 44 37 35.9 37 26C37 16.1 28.9 8 19 8C9.1 8 1 16.1 1 26C1 35.9 9.1 44 19 44Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 23V28",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9994 35.4098H12.9394C9.46944 35.4098 8.01944 32.9298 9.69944 29.8998L12.8194 24.2798L15.7594 18.9998C17.5394 15.7898 20.4594 15.7898 22.2394 18.9998L25.1794 24.2898L28.2994 29.9098C29.9794 32.9398 28.5194 35.4198 25.0594 35.4198H18.9994V35.4098Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9961 31H19.0051",
			stroke: "#FC8210",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCriceleAlert;
